import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { push } from "connected-react-router"
import { get } from "lodash"

import Loader from "components/Loader/Loader"
import ContentBox from "components/ContentBox/ContentBox"

import { getGenre } from "actions/genres"

import selectCategories from "selectors/categories"
import selectGenre from "selectors/genres"
import { selectReferencesModel } from "selectors/references"

import FormatterHelper from "helpers/formatter"
import { updateMeta, restoreDefaultMeta } from "helpers/meta"
import routeHelper from "helpers/route"
import { getAssetURL } from "helpers/static"

import consts from "consts"
import styles from "./pageGenre.css"
import PageGenreView from "./PageGenreView"
import { LOCALE } from "consts/locale"

@connect(state => ({
  genre: selectGenre(state),
  categories: selectCategories(state),
  references: selectReferencesModel(state),
}))
export default class PageGenre extends Component {
  static propTypes = {
    categories: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    references: PropTypes.object.isRequired,
    genre: PropTypes.object.isRequired,
  }

  static cache = consts.cache.defaultCacheMaxAge

  static fetchData(dispatch, state, renderProps) {
    const currentPage = routeHelper.getCurrentPage(get(renderProps, "match.params.page", 0))
    const { categoryId, genreId } = renderProps.match.params

    return dispatch(getGenre(categoryId, genreId, currentPage))
  }

  static getMeta(state, renderProps) {
    const references = selectReferencesModel(state)
    const category = references.getCategory(renderProps.match.params.categoryId)
    const currentPage = routeHelper.getCurrentPage(renderProps.match.params.page)
    const genre = references.getSubCategory(renderProps.match.params.genreId)

    const title =
      category.label === "Films" || category.label === "Séries"
        ? `${genre.label} à la télévision en streaming avec Molotov ${currentPage ? ` - page ${currentPage + 1}` : ""}`
        : `${genre.label} à la télévision en direct avec Molotov ${currentPage ? ` - page ${currentPage + 1}` : ""}`

    const meta = {
      title,
      description: `${category.label} à la télé en direct à retrouver et regarder en téléchargeant Molotov ${
        currentPage ? ` - page ${currentPage + 1}` : ""
      }`,
    }

    if (currentPage === 0) {
      meta.canonical = `${consts.externalLink.landing}${FormatterHelper.basic(consts.routes.genre, {
        locale: LOCALE,
        categoryId: category.id,
        categorySlug: category.slug_seo,
        genreId: genre.id,
        genreSlug: genre.slug_seo,
      })}`
    }
    meta.og = {
      type: "website",
      image: getAssetURL("image.pageHome.ogImage"),
      imageAlt: `${category.label} en streaming et replay`,
      url: `${consts.externalLink.landing}${FormatterHelper.basic(consts.routes.genre, {
        locale: LOCALE,
        categoryId: category.id,
        categorySlug: category.slug_seo,
        genreId: genre.id,
        genreSlug: genre.slug_seo,
      })}`,
      title: `${category.label} en streaming et en replay - Regardez la télévision sur Internet - Molotov.tv`,
      description: "Téléchargez gratuitement l'application Molotov TV afin de regarder vos programmes en direct et en replay.",
    }

    return meta
  }

  static getHeadContent(state, renderProps) {
    const references = selectReferencesModel(state)
    const genre = references.getSubCategory(renderProps.match.params.genreId)

    const currentPage = routeHelper.getCurrentPage(renderProps.match.params.page)
    const { categoryId, categorySlug, genreId, genreSlug } = renderProps.match.params
    const result = []

    if (typeof genre.getSections !== "function") {
      return ""
    }

    const maxPage = Math.max.apply(
      null,
      genre.getSections().map(s => s.getNumberOfPages())
    )

    if (currentPage > 0) {
      const prevUrl = FormatterHelper.basic(consts.routes.genre, {
        locale: LOCALE,
        categoryId,
        categorySlug,
        genreId,
        genreSlug,
        page: currentPage,
      })
      result.push(<link rel="prev" href={prevUrl} />)
    }

    if (currentPage < maxPage - 1) {
      const nextUrl = FormatterHelper.basic(consts.routes.genre, {
        locale: LOCALE,
        categoryId,
        categorySlug,
        genreId,
        genreSlug,
        page: currentPage + 2,
      })
      result.push(<link rel="next" href={nextUrl} />)
    }

    return result
  }

  setMeta(props) {
    updateMeta(this.constructor.getMeta(props, props))
  }

  generateTitle(label, currentPage) {
    return `${label} à regarder en streaming sur Molotov ${currentPage ? `- Page ${currentPage + 1}` : ""}`
  }

  componentDidMount() {
    if (!global.serverRendered) {
      this.constructor.fetchData(this.props.dispatch, this.props, this.props)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.categoryId !== this.props.match.params.categoryId ||
      prevProps.match.params.genreId !== this.props.match.params.genreId ||
      prevProps.match.params.page !== this.props.match.params.page
    ) {
      this.constructor.fetchData(this.props.dispatch, this.props, this.props)
    }

    this.setMeta(this.props)

    if (this.props.genre.getSections) {
      const maxPage =
        Math.max.apply(
          null,
          this.props.genre.getSections().map(s => s.getNumberOfPages())
        ) - 1
      const currentPage = routeHelper.getCurrentPage(this.props.match.params.page)

      if (!this.redirectStarted && currentPage > maxPage) {
        this.redirectStarted = true
        const category = this.props.references.getCategory(this.props.match.params.categoryId)

        this.props.dispatch(
          push(
            FormatterHelper.basic(consts.routes.genre, {
              locale: LOCALE,
              categoryId: this.props.match.params.categoryId,
              categorySlug: category.slug_seo,
              genreId: prevProps.match.params.genreId,
              genreSlug: prevProps.match.params.genreSlug,
            })
          )
        )
      }
    }
  }

  componentWillUnmount() {
    restoreDefaultMeta()
  }

  render() {
    const {
      genre,
      match: {
        params: { categoryId, page, genreId, categorySlug, genreSlug },
      },
    } = this.props

    if (genre?.pending) {
      return <Loader centerInParent />
    }

    if (!genre?.pending && !genre?.getSections) {
      return (
        <ContentBox className={styles.errorBox}>
          <h2 className={styles.errorTitle}>La catégorie que vous recherchez semble introuvable.</h2>
          <Link className={styles.errorLink} to={FormatterHelper.basic(consts.routes.seoHome, { locale: LOCALE })}>
            Retourner au programme TV
          </Link>
        </ContentBox>
      )
    }

    return <PageGenreView categoryId={categoryId} page={page} genreId={genreId} categorySlug={categorySlug} genreSlug={genreSlug} />
  }
}
